import { type RouteTypes } from '@energovizor/api-client';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import userSelector from '@/store/selectors/userSelector';
import { apiClient } from './apiClient';
import { useGetActiveMunicipality } from './getMunicipality';

type ConsumptionReminderAlertsResponse = RouteTypes['/buildings/consumption-reminder-alerts']['get']['response'];
export type ConsumptionReminderAlert = NonNullable<ConsumptionReminderAlertsResponse['payload']>[number];

export const consumptionReminderAlertsQueryKey = (municipalityId?: string | null, buildingId?: string) => {
  return ['consumption-reminder-alerts', municipalityId ?? null, buildingId ?? 'all'] as const;
};

export const useGetConsumptionReminderAlerts = ({
  buildingId,
  enabled = true,
}: {
  buildingId?: string;
  enabled?: boolean;
} = {}) => {
  const user = useSelector(userSelector);
  const municipalityId = useGetActiveMunicipality({ enabled });

  return useQuery({
    queryKey: consumptionReminderAlertsQueryKey(municipalityId, buildingId),
    enabled: enabled && !!municipalityId && !!user && user.type === 'client' && !!user.verifiedEmail && !!user.verifiedByAdmin,
    queryFn: async () => {
      const response = await apiClient.get('/buildings/consumption-reminder-alerts', {
        params: {
          buildingId,
        },
      });

      return (response.data as ConsumptionReminderAlertsResponse).payload ?? [];
    },
  });
};
